
<div class="color_bubble" v-bind:class="colorBubbleVariant">
    <div class="row align-items-center">
        <div class="icon_column col col-1 text-center">
            <slot name="icon"></slot>
        </div>
        <div class="col heading bold" v-bind:class="colorBubbleColumn1">
            <slot name="heading"></slot>
        </div>
        <div class="col description text-right" v-bind:class="colorBubbleColumn2">
            <slot name="description"></slot>
        </div>
    </div>
</div>
